import React from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";

export default function Blank(props) {
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      Blank
    </div>
  );
}
